import React, { Fragment } from 'react';
import {
  Accordion,
  Button,
  Divider,
  Form,
  Grid,
  Header,
  Icon,
} from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import { NotificationDialog, DatePickerCustomButton } from 'Components';
import { YesNoDialog } from 'Components/dialogs/YesNoDialog';

import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { DatePickerField } from 'Common/SemanticWrapper';
import { PhysicalEnum } from 'Common/FieldEnum';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { PHYSICAL_FORM_NAME } from 'Common/FormEnum';
import ReactTable from 'Common/ReactTableWrapper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { GridEnum } from 'Common/Constants/Enumeration/GridEnum';
import { GroupByEnum } from 'Common/Constants/Enumeration/PhysicalEnum';
import { PrintSortTypeEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { SiteComponent } from 'Common/SiteComponent';

const PhysicalList = props => {
  const viewStatusOptions = [
    { value: 'All', label: 'All' },
    { value: 'Open', label: 'Open' },
    { value: 'Closed', label: 'Closed' },
  ];

  const sortOptions = [
    { value: PrintSortTypeEnum.ItemCode, label: 'Item Id' },
    { value: PrintSortTypeEnum.ItemDescription, label: 'Item Description' },
  ];

  const groupByOptions = [
    { value: GroupByEnum.NONE, label: 'None' },
    { value: GroupByEnum.ACCOUNTCATEGORY, label: 'Account Category' },
  ];

  const {
    onChangeOfFromDT,
    onChangeOfToDT,
    toDateMin,
    fromDateMax,
    setSelectedSite,
    setShowStatusOption,
    clearFilters,
    physicalListData,
    reactTableRef,
    loading,
    columns,
    printPhysical,
    gridPreferenceLoading,
    gridPreferenceSubmitting,
    showDeleteModel,
    handleDeleteDialog,
    showDeleteConfirm,
    closeDeleteOrderConfirm,
    selectedPhysicalRecord,
    activeIndexForFilter,
    activeIndexForSort,
    handleClick,
  } = props;
  let deleteQuestion =
    'Are you sure you would like to permanently delete all checked physicals?';
  if (selectedPhysicalRecord) {
    deleteQuestion = `Are you sure you would like to permanently delete physicalId# ${selectedPhysicalRecord} ?`;
  }
  return (
    <Fragment>
      <Form>
        <Accordion fluid styled>
          <Accordion.Title
            active={!activeIndexForFilter}
            index={0}
            option={0}
            onClick={handleClick}
          >
            <Icon name="dropdown" />
            <span className="text-orange">Filter By</span>
          </Accordion.Title>
          <Accordion.Content active={!activeIndexForFilter}>
            <Grid className="grid-spacing">
              <Grid.Row columns={2}>
                <Grid.Column width={8}>
                  <div style={{ paddingTop: 25 }}>
                    <Header as="h4">Date Range</Header>
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={4}>
                <Grid.Column>
                  <Field
                    component={DatePickerField}
                    label={'From:'}
                    dateFormat={DATE_FORMAT_FOR_UI}
                    name={PhysicalEnum.FromDT}
                    onChange={onChangeOfFromDT}
                    maxDate={fromDateMax}
                    type={'text'}
                    dropdownMode="select"
                    customInput={<DatePickerCustomButton />}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    component={DatePickerField}
                    label={'To:'}
                    dateFormat={DATE_FORMAT_FOR_UI}
                    name={PhysicalEnum.EndDT}
                    type={'text'}
                    onChange={onChangeOfToDT}
                    minDate={toDateMin}
                    dropdownMode="select"
                    customInput={<DatePickerCustomButton />}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={2}>
                <Grid.Column width={5}>
                  <div style={{ paddingTop: 25 }}>
                    <Header as="h4">Site</Header>
                  </div>
                </Grid.Column>
                <Grid.Column>
                  <div style={{ paddingTop: 25 }}>
                    <Header as="h4">View Status</Header>
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={3}>
                <Grid.Column width={5}>
                  <SiteComponent
                    name={PhysicalEnum.Site}
                    label={''}
                    isForm={true}
                    isAllRequired={true}
                    showAllActiveSites={true}
                    onChange={setSelectedSite}
                    isAllValueZero={true}
                  />
                </Grid.Column>
                <Grid.Column width={8}>
                  <ReduxFormButtonGroup
                    options={viewStatusOptions}
                    type={'button'}
                    formName={PHYSICAL_FORM_NAME}
                    fieldName={PhysicalEnum.ViewStatusOptions}
                    onChange={setShowStatusOption}
                  />
                </Grid.Column>
                <Grid.Column width={3}>
                  <Button
                    content="Clear Filters"
                    onClick={clearFilters}
                    type={'button'}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Accordion.Content>
          <Accordion.Title
            active={!activeIndexForSort}
            index={0}
            option={1}
            onClick={handleClick}
          >
            <Icon name="dropdown" />
            <span className="text-orange">Sort By</span>
          </Accordion.Title>
          <Accordion.Content active={!activeIndexForSort}>
            <Grid>
              <Grid.Row>
                <Grid.Column className="paddingTop25" width={5}>
                  <div>
                    <Header as="h4">Sort By</Header>
                  </div>
                </Grid.Column>
                <Grid.Column className="paddingTop25" width={8}>
                  <div>
                    <Header as="h4">Group By</Header>
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={3} className={'pt10'}>
                <Grid.Column width={5} verticalAlign={'bottom'}>
                  <ReduxFormButtonGroup
                    options={sortOptions}
                    formName={PHYSICAL_FORM_NAME}
                    fieldName={PhysicalEnum.SortOptions}
                    type={'button'}
                  />
                </Grid.Column>
                <Grid.Column width={5}>
                  <ReduxFormButtonGroup
                    options={groupByOptions}
                    formName={PHYSICAL_FORM_NAME}
                    fieldName={PhysicalEnum.GroupByOptions}
                    type={'button'}
                  />
                </Grid.Column>
                <Grid.Column floated={'right'} textAlign={'right'}>
                  <Button
                    disabled={loading}
                    content="Print"
                    type={'button'}
                    style={{ marginLeft: 10 }}
                    onClick={printPhysical}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Accordion.Content>
        </Accordion>
        <Divider horizontal />
        <Grid>
          <Grid.Row columns={1} className={'remove-spacing'}>
            <Grid.Column>
              <ReactTable
                reactTableRef={reactTableRef}
                defaultPageSize={20}
                showPageSizeOptions={true}
                minRows={0}
                data={physicalListData}
                noDatatext={loading ? '' : 'No rows found'}
                loadingText={loading ? 'Loading...' : ''}
                resizable={false}
                className="-striped -highlight modalGrid"
                columns={columns}
                loading={
                  loading || gridPreferenceLoading || gridPreferenceSubmitting
                }
                draggableColumns={true}
                showHideColumn={true}
                menu={'hasCogs'}
                saveState={{
                  tableName: TableNamesEnum.PHYSICAL_LIST_TABLE,
                }}
                hasSelectAllColumn={true}
                gridName={GridEnum.INV_Physical_View}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <YesNoDialog
          showDialog={showDeleteModel}
          title={'Delete Physical'}
          question={deleteQuestion}
          yesCallback={() => {
            handleDeleteDialog(true);
          }}
          noCallback={() => {
            handleDeleteDialog(false);
          }}
        />
        <NotificationDialog
          title={'Delete Usage'}
          showDialog={showDeleteConfirm}
          message={'Please only select open physical(s) to delete'}
          onOkClick={closeDeleteOrderConfirm}
        />
      </Form>
    </Fragment>
  );
};

PhysicalList.propTypes = {
  onChangeOfFromDT: PropTypes.func,
  onChangeOfToDT: PropTypes.func,
  toDateMin: PropTypes.object,
  fromDateMax: PropTypes.object,
  setSelectedSite: PropTypes.func,
  setShowStatusOption: PropTypes.func,
  clearFilters: PropTypes.func,
  physicalListData: PropTypes.array,
  reactTableRef: PropTypes.object,
  loading: PropTypes.bool,
  columns: PropTypes.array,
  printPhysical: PropTypes.func,
  savePreference: PropTypes.func,
  gridPreferenceLoading: PropTypes.bool,
  gridPreferenceSubmitting: PropTypes.bool,
  showDeleteModel: PropTypes.bool,
  handleDeleteDialog: PropTypes.func,
  showDeleteConfirm: PropTypes.bool,
  closeDeleteOrderConfirm: PropTypes.func,
  selectedPhysicalRecord: PropTypes.number,
};
export default PhysicalList;



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/physical/components/physicalList/PhysicalList.js